import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as popoverActions from 'actions/popoverActions';
import * as optimizelyUtil from 'utils/optimizely';

import './PopoverTrigger.scss';

/* istanbul ignore next */
const mapStateToProps = () => ({});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    popoverActionsBound: bindActionCreators(popoverActions, dispatch),
  };
}

export class PopoverTriggerLayout extends Component {
  static propTypes = {
    popoverActionsBound: PropTypes.object,
    label: PropTypes.string,
    children: PropTypes.node,
    position: PropTypes.string,
    optimizelyId: PropTypes.string,
    content: PropTypes.object,
    extraClass: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  componentWillUnmount() {
    if (this.mousedOver) {
      this.hidePopover();
    }
  }

  showPopover = (event) => {
    const { popoverActionsBound, content, disabled } = this.props;
    const optimizelyId = event.currentTarget.dataset.optimizelyId;

    if (!disabled) {
      popoverActionsBound.showPopover({
        position: event.currentTarget.dataset.position,
        boundingClientRect: event.currentTarget.getBoundingClientRect(),
      }, content);
      this.mousedOver = true;
      if (optimizelyId) {
        optimizelyUtil.fireEvent(optimizelyId, 'clicked');
      }
    }
  };

  hidePopover = () => {
    const { popoverActionsBound } = this.props;
    popoverActionsBound.hidePopover();
    this.mousedOver = false;
  };

  togglePopover = (event) => {
    const { popoverActionsBound, content, disabled } = this.props;
    event.preventDefault();
    if (!this.mousedOver && !disabled) {
      popoverActionsBound.togglePopover({
        position: event.currentTarget.dataset.position,
        boundingClientRect: event.currentTarget.getBoundingClientRect(),
      }, content);
    }
  };

  render() {
    const { label, position, optimizelyId, extraClass } = this.props;

    return (
      <a
        href="#"
        onClick={this.togglePopover}
        onMouseEnter={this.showPopover}
        onMouseLeave={this.hidePopover}
        data-position={position}
        data-optimizely-id={optimizelyId}
        className={`popover-trigger ${extraClass || ''} ${label ? 'popover-trigger--underlined' : ''}`}
      >
        { this.props.children || label }
      </a>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PopoverTriggerLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/PopoverTriggerLayout/PopoverTriggerLayout.jsx
 **/